import { Component} from '@angular/core';

@Component({
    selector: 'vouchersOrganization-main',
    templateUrl: './vouchersOrganization-main.tmpl.html'
})

export class VouchersOrganizationMain {
    editMode: boolean = null; 

    public setVal(val:boolean) {
        this.editMode = val;  
    }
}
  